const musicLinkUrlPartsDE = {
    "view": {
        "table": {
            "title": "Ihre Liste der Musiklinks-Url-Teile",
            "column": {
                "part": "Teil",
                "owner": "Besitzer",
                "action": "Aktion"
            },
            "placeholder": {
                "search": "Suche..."
            },
            "button": {
                "exportCSV": "CSV exportieren"
            }
        },
        "message": {
            "success": "Musiklink-Url-Teil wurde entfernt!",
            "error": "Etwas ist schiefgelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "noUrlparts": "Derzeit wird diese Funktion nur wenigen ausgewählten Benutzern angeboten, aber die gute Nachricht ist, dass Sie sie auch bald nutzen können. Bleiben Sie dran!"
        },
        "modal": {
            "delete": {
                "header": "{{mlUrlpart}} löschen?",
                "body": "Sind Sie sicher, dass Sie diesen Musiklink-Url-Teil löschen möchten?"
            },
            "canNotDelete": {
                "header": "Musiklink-Url-Teil {{mlUrlPart}} kann nicht gelöscht werden",
                "body": "Musiklink-Url-Teil {{mlUrlPart}} kann nicht gelöscht werden, da er bereits mit einem Musiklink verknüpft ist."
            }
        }
    },
    "add": {
        "form": {
            "label": {
                "subUser": "Unterbenutzer",
                "part": "Teil",
                "owner": "Besitzer",
                "addUrlPart": "Url-Teil hinzufügen",
                "editUrlPart": "Url-Teil bearbeiten"
            },
            "placeholder": {
                "subUser": "Unterbenutzer auswählen..."
            },
            "help_text": {
                "subUser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie einen Musiklink für einen Ihrer Unterbenutzer hinzufügen möchten, andernfalls lassen Sie es unmarkiert."
            },
            "button": {
                "reset": "Zurücksetzen",
                "submit": "Einreichen"
            },
            "validation": {
                "part": {
                    "required": "Teil ist erforderlich",
                    "max": "Muss genau 16 Zeichen lang sein"
                }
            },
            "message": {
                "subUserLimit": "Dieser Unterbenutzer hat das maximale Limit von 10 Url-Teilen erreicht.",
                "urlPartAlreadyTaken": "Diese Musiklink-URL ist bereits von Ihrem Konto oder einem anderen Benutzerkonto belegt. Bitte versuchen Sie etwas anderes."
            }
        },
        "message": {
            "addSuccess": "Musiklink-Url-Teil wurde hinzugefügt!",
            "updateSuccess": "Musiklink-Url-Teil wurde aktualisiert!",
            "error": "Etwas ist schiefgelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        }
    }
};

export default musicLinkUrlPartsDE;